import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Icon, Table, TableColumnOpcoes, TableSearch } from '@components';
import { getFontesDados, reset as resetFontesDados } from '@ducks/conectoresFontesDados';

export default function TableFontesDados() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const fontesDados = useSelector(({ conectoresFontesDados }) => conectoresFontesDados.get('fontesDados').toArray());
  const loadingFontesDados = useSelector(({ conectoresFontesDados }) => conectoresFontesDados.get('loadingFontesDados'));

  const handleSearch = () => {
    dispatch(getFontesDados(id));
  };

  const handleReset = () => {
    dispatch(resetFontesDados());
  };

  useEffect(() => {
    handleReset();
  }, []);

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Fonte',
      dataIndex: 'nm',
      key: 'nm',
      ...TableSearch('nm', 'fonte', { st1, setSt1, st2, setSt2 }),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'options',
      align: 'right',
      width: '7%',
      render: (text, item) => (
        <TableColumnOpcoes>
          <Icon.Edit action={() => history.push(`/conectores/configuracao/${item.idConfiguracao}/fonte/dado/${item.id}`)} />
          <Icon.Detail action={() => history.push(`/conectores/configuracao/${item.idConfiguracao}/fonte/dado/${item.id}/tarefas`)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey="id" columns={columns} dataSource={fontesDados} loading={loadingFontesDados} hidePagination />;
}
